<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-title v-if="context.titel" size="4xl" tag="h1">
			{{ context.titel }}
		</nk-title>

		<nk-image
			v-if="context.bild"
			class="sm:ml-4 sm:float-right"
			:src="context.bild"
			:alt="context.bildtext"
			:caption="context.bildtext"
			:copyright="context.bildcopyright"
			lightbox
			image-class="w-full md:max-w-xs xl:max-w-sm"
		/>

		<div
			v-if="context.einleitung"
			class="nk-cms-content text-lg"
			v-html="context.einleitung"
		/>

		<div v-if="context.text" class="nk-cms-content" v-html="context.text" />

		<div class="clear-both" />
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateBaugebieteDetail',
	mixins: [TemplatesDefault],
};
</script>
